import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CheckGroupPermissions } from "@helpers/checkGroupPermissions";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { ResolveQuarantineDto } from "@interfaces/dto/resolveQuarantineDto.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { AppSettingsService } from "@services/appSettings.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { QuarantinedPartService } from "@services/quarantinedPart.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "quarantinedParts",
	styleUrls: ["quarantinedParts.css"],
	templateUrl: "quarantinedParts.html"
})
export class QuarantinedPartsAdminComponent {
	canExportGrid = false;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	isProductionManagement = false;
	isQualityManagement = false;
	isSuperAdmin = false;
	itemType = "Quarantined Part"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	popupAddButtonOptions: any = { onClick: () => this.resolveQuarantine(), text: "Resolve" };
	popupAmountQuarantined = 0;
	popupCloseButtonOptions: any = { onClick: () => this.closePopup(), text: "Close" };
	popupResolveQuarantine: ResolveQuarantineDto = new ResolveQuarantineDto();
	popupTitle = "Resolve Quarantine";
	popupVisible = false;
	title: string;
	
	constructor(private router: Router, private toastService: ToastService, private appSettingsService: AppSettingsService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService, private itemService: QuarantinedPartService) {
		this.title = `${this.itemType}s`;
		this.getItems();
		this.checkGridExportPermissions();
		
		this.isProductionManagement = CheckGroupPermissions(appSettingsService, "Production Management");
		this.isQualityManagement = CheckGroupPermissions(appSettingsService, "Quality Management");
		this.isSuperAdmin = CheckGroupPermissions(appSettingsService, "Super Admin");

		this.isResolveAvailableForRow = this.isResolveAvailableForRow.bind(this);
		this.resolveQuarantinePopup = this.resolveQuarantinePopup.bind(this);
	}

	boolYesNo(cellInfo: any) {
		if (cellInfo.value === true) {
			return "YES";
		}
		else {
			return "NO";
		}
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Quarantined Parts")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	closePopup() {
		this.popupVisible = false;
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getDataGrid()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}
	
	isResolveAvailableForRow(e: any) {
		return e.row.data.quarantineResolved === false && (this.isProductionManagement || this.isQualityManagement || this.isSuperAdmin);
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Quarantined Parts";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	resolveQuarantine() {
		this.itemService.resolve(this.popupResolveQuarantine)
			.subscribe(
				() => {
					this.getItems();
					this.closePopup();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	resolveQuarantinePopup(e: any) {
		this.popupResolveQuarantine = new ResolveQuarantineDto();
		this.popupResolveQuarantine.quarantinedPartId = e.row.data.id;
		this.popupAmountQuarantined = e.row.data.amountQuarantined;
		this.popupVisible = true;
	}
}